import { logo } from "../lib/constants";
import { AlertCircleIcon, Bell, CheckCircle, Gift } from "lucide-react";
import { format } from "date-fns";


export const Image1 = () => {

	return (
		<div className="bg-gray-100 w-full h-full bg-cover bg-center" style={{ backgroundImage: `url(background.png)` }}>
			<div className="bg-white m-[20px] rounded-2xl p-[20px]">
				<h2 className="text-lg font-medium">Hey! We're Jake & George - two students who thought Canvas could be better.</h2>
				<p className="text-gray-500 text-base mt-[20px]">so we built BetterCampus to make school feel less overwhelming.</p>
				<p className="text-gray-500 text-base mt-[20px]">now you're joining <span className="text-black font-medium">1.5M+ students</span> using BetterCampus.</p>
			</div>
		</div>
	)
}


export const Image2 = () => {

	return (
		<div className="bg-[#ffd28e] w-full h-full bg-cover bg-center bg-no-repeat bg-size-[200%]" style={{ backgroundImage: `url(iconxl.png)` }}>
		</div>
	)
}

export const EmptyIcon = () => {

	return (
		<div className="bg-[#ffd28e] w-full h-full bg-cover bg-center bg-no-repeat bg-size-[190%]" style={{ backgroundImage: `url(iconemptylg.png)` }}>
		</div>
	)
}

const TrialTimelineItem = ({ title, description, icon, iconBgColor, iconBorder }: { title: string, description: string, icon: React.ReactNode, iconBgColor: string, iconBorder: string }) => {
	return (
		<div className="flex gap-[15px] relative z-1">
			<div className="flex shrink-0 items-center justify-center rounded-full w-[32px] h-[32px] text-white border border-gray-200" style={{ backgroundColor: iconBgColor, borderColor: iconBorder, }}>
				{icon}
			</div>
			<div>
				<h6 className="font-medium text-base text-black">{title}</h6>
				<p className="text-gray-500 text-base text-sm">{description}</p>
			</div>
		</div>
	)
}

export const TrialTimelineImage = () => {

	const trialReminderDate = new Date(new Date().setDate(new Date().getDate() + 12));
	const paymentDueDate = new Date(new Date().setDate(new Date().getDate() + 14));

	return (
		<div className="bg-gray-100 w-full h-full bg-cover bg-center flex items-center bg-size-[200%]" style={{ backgroundImage: `url(iconxl.png)` }}>
			<div className="bg-white rounded-2xl p-[20px] m-[30px] w-full flex flex-col gap-4 relative">
				<div className="absolute top-0 left-0 h-full pl-[33px] py-[48px] z-0">
					<div className="w-[6px] h-full rounded-full" style={{ "background": "linear-gradient(180deg, #2b7fff 0%, #2b7fff 15%, #f3f4f6 15%, #f3f4f6 100%)" }} />
				</div>
				<TrialTimelineItem title="Today - Free trial starts" description="You'll have 14 days to try BetterCampus Pro for free" iconBgColor="#2b7fff" iconBorder="#2b7fff" icon={<Gift className="h-[20px] w-[20px] text-white" />} />
				<TrialTimelineItem title={format(trialReminderDate, "MMM d, yyyy")} description="We'll send you a reminder before your trial ends" iconBgColor="white" iconBorder={"#e5e7eb"} icon={<Bell className="h-[20px] w-[20px] text-black" />} />
				<TrialTimelineItem title={format(paymentDueDate, "MMM d, yyyy")} description="Subscription starts, unless you cancel before" iconBgColor="white" iconBorder={""} icon={<CheckCircle className="h-[20px] w-[20px] text-[#56aa33]" />} />
			</div>
		</div>
	)
}

export const TrialTimelineImageSkipped = () => {

	const trialReminder = new Date(new Date().setDate(new Date().getDate() + 12));
	const paymentDue = new Date(new Date().setDate(new Date().getDate() + 14));

	const now = new Date();
	const trialReminderDate = new Date(trialReminder.setDate(now.getDate() + 12));
	const paymentDueDate = new Date(paymentDue.setDate(now.getDate() + 14));

	return (
		<div className="bg-gray-200 w-full h-full bg-cover bg-center flex items-center bg-size-[200%]" style={{ backgroundImage: `url(iconxl.png)` }}>
			<div className="bg-white rounded-2xl p-[20px] m-[30px] w-full flex flex-col gap-4 relative">
				<div className="absolute top-0 left-0 h-full pl-[33px] py-[48px] z-0">
					<div className="w-[6px] h-full rounded-full" style={{ "background": "linear-gradient(180deg, #2b7fff 0%, #2b7fff 15%, #f3f4f6 15%, #f3f4f6 100%)" }} />
				</div>
				<TrialTimelineItem title="Today - Free trial starts" description="You'll have 14 days to try BetterCampus Pro for free" iconBgColor="#2b7fff" iconBorder="#2b7fff" icon={<Gift className="h-[20px] w-[20px] text-white" />} />
				<TrialTimelineItem title={format(trialReminderDate, "MMM d, yyyy")} description="We'll send you a reminder before your trial ends" iconBgColor="white" iconBorder={"#e5e7eb"} icon={<Bell className="h-[20px] w-[20px] text-black" />} />
				<TrialTimelineItem title={format(paymentDueDate, "MMM d, yyyy")} description="Downgraded to the free plan" iconBgColor="white" iconBorder="#e5e7eb" icon={<AlertCircleIcon className="h-[20px] w-[20px] text-red-500" />} />
			</div>
		</div>
	)
}

export const WelcomeImage = () => {
	return (
		<div className="bg-white w-full h-full bg-cover bg-center overflow-hidden relative gradient-backdrop">
			<img src={logo} className="w-full h-full object-contain absolute" style={{ zIndex: "10", "opacity": ".05", "top": "-25%", "right": "-15%", "transform": "rotate(-140deg)" }}></img>
			<div className="frosted-backdrop absolute top-0 left-0 w-full h-full"></div>
		</div>
	)
}

const TeamImage = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className="w-full h-full relative flex flex-col justify-end overflow-hidden">
			<div className="absolute w-full h-full gradient-backdrop z-0">
				<img src={"iconlg.png"} className="w-[105%] max-w-[600px] object-contain absolute z-10 top-[-100px] right-[-10%]" ></img>
				<div className="frosted-backdrop absolute top-0 left-0 w-full h-full"></div>
			</div>
			<div className="relative z-1 flex flex-col">
				<div className="flex items-center justify-center">
					<img src="group.png" className="shadow-lg border-[7px] border-white w-[170px] rounded-xl rotate-[-10deg] translate-x-[10px]"></img>
					<img src="closet.png" className="shadow-lg border-[7px] border-white w-[170px] rounded-xl rotate-[15deg] translate-x-[-10px]"></img>
				</div>
				{children}
			</div>
		</div>
	)
}

export const Image3 = () => {
	return (
		<TeamImage>
			<div className="p-[20px] bg-white text-right">
				<h2 className="text-lg font-medium">hope your semester was great!!</h2>
				<p className="text-gray-500 text-sm mt-[5px] max-w-[80%] ml-auto">ours? george was legit sleeping in a closet to save $ and I (Jake) was on campus every day interviewing students</p>
				<p className="text-gray-500 text-xs mt-[20px]">made with 💙 for students everywhere</p>
			</div>
		</TeamImage>
	)
}

export const Image4 = () => {
	return (
		<TeamImage>
			<div className="p-[25px] bg-white text-right">
				<h2 className="text-lg font-medium">we’re jake & george - 2 students who thought canvas could be better</h2>
				<p className="text-gray-500 text-sm mt-[5px]">so we built BetterCampus to make school easier</p>
				<p className="text-gray-500 text-xs mt-[20px]">made with 💙 for students everywhere</p>
			</div>
		</TeamImage>
	)
}

export const JoinStudentsImage = () => {

	/*
	const [number, setNumber] = useState(1659940);
	const prevDayInstalls = 17341;

	useEffect(() => {
		const interval = setInterval(() => {
			setNumber(number + 20);
		}, 2500);
		return () => clearInterval(interval);
	}, [number]);
	*/

	return (
		<div className="absolute w-full h-full z-0 relative">
			<div className="w-full h-full absolute top-0 left-0" style={{ "background": "#eaeaea" }}></div>
			<p className="max-w-[100px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-xl font-semibold text-center">
				Join 1.5M+ students worldwide
			</p>
			<div className="w-full h-full bg-size-[180%] bg-center z-1 relative" style={{ backgroundImage: `url(iconemptylg.png)` }} ></div>
		</div>
	)
}

export const CongratulationsImage = () => {
	return (
		<div className="absolute w-full h-full z-0 relative">
			<div style={{ "background": "linear-gradient(120deg, var(--brand-1), var(--brand-2))" }} className="w-full h-full absolute top-0 left-0 opacity-35"></div>
			<p className="max-w-[180px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-lg font-semibold text-center ">Congratulations on joining 1.5M+ students worldwide!</p>
			<div className="w-full h-full bg-size-[180%] bg-center z-1 relative" style={{ backgroundImage: `url(iconemptylg.png)` }} ></div>
		</div>
	)
}

export const Image5 = () => {
	return (
		<TeamImage>
			<div className="p-[25px] bg-white text-right">
				<h2 className="text-lg font-medium">before we get started...</h2>
				<p className="text-gray-500 text-sm mt-[5px]">we need to make sure you're old enough to make an account (shoutout COPPA)</p>
				<p className="text-gray-500 text-xs mt-[20px]">made with 💙 for students everywhere</p>
			</div>
		</TeamImage>
	)
}

export const ThemeImage = () => {

	return (
		<div className="w-full h-full bg-cover bg-bottom flex items-center" style={{ backgroundImage: `url(theme.png)` }}>

		</div>
	)
}

export const TiktokImage = () => {
	return (
		<div className="w-full h-full bg-cover bg-center relative flex items-center justify-center">
			<div className="absolute w-full h-full gradient-backdrop z-0">
				<div className="frosted-backdrop absolute top-0 left-0 w-full h-full"></div>
			</div>
			<div className="w-[64%] h-full relative">
				<img src="phone.png" className="w-full h-full object-contain absolute top-0 left-0 z-1" />
				<img src="tiktokphone.png" className="w-[92%] ml-[4%] h-full object-contain absolute top-0 left-0 z-0" />

			</div>
		</div>
	)
}

export const DiscordImage = () => {
	return (
		<div className="w-full h-full relative flex items-center justify-center overflow-visible">
			<div className="absolute w-full h-full z-0" style={{ background: "#5865F2" }}>
				<div className="w-full h-full bg-size-[180%] bg-center opacity-10" style={{ backgroundImage: `url(iconemptylg.png)` }} />
			</div>
			<div className="relative z-1 translate-x-8 w-[375px]">
				<div className="bg-[#1a1a1a] rounded-xl shadow-2xl overflow-hidden">
					<div className="flex items-center gap-[6px] px-[12px] py-[10px] bg-[#2d2d2d]">
						<div className="w-[10px] h-[10px] rounded-full bg-[#ff5f57]" />
						<div className="w-[10px] h-[10px] rounded-full bg-[#febc2e]" />
						<div className="w-[10px] h-[10px] rounded-full bg-[#28c840]" />
					</div>
					<img src="discord_server.webp" className="w-full" />
				</div>
			</div>
		</div>
	)
}